import React, { useState } from "react";

const AdministrationFeesContext = React.createContext();

export const useAdministrationFeesProvider = () => React.useContext(AdministrationFeesContext);

export const AdministrationFeesProvider = ({ children }) => {
    const [tabIndex, setTabIndex] = useState(0);
    const [filters, setFilters] = useState(null);
    //const [leftDates, setLeftDates] = useState([{}]);
    //const [headerDates, setHeaderDates] = useState([{}]);
    //const [monthTotals, setMonthTotals] = useState([{}]);
    //const [agedDebtorFilterApplied, setAgedDebtorFilterApplied] = useState(false);
    const currentSearchType = tabIndex===0 ? "fees" : tabIndex===1 ? "cash" : tabIndex===2 ? "debtors" : tabIndex===3 ? "ageddebtors" : null;
    return (
        <AdministrationFeesContext.Provider value = {{ 
            currentSearchType,
            tabIndex, 
            setTabIndex,
            filters,
            setFilters
            //leftDates,
            //setLeftDates,
            //headerDates,
            //setHeaderDates,
            //monthTotals,
            //setMonthTotals,
            //agedDebtorFilterApplied,
            //setAgedDebtorFilterApplied
        }}>
            {children}
        </AdministrationFeesContext.Provider>
    );
}
